import { CLEAR_SCROLLED_COMPONENT, SCROLL_TO_COMPONENT } from '@instructure/quiz-common';
export function scrollToItem(scrolledComponentKey) {
  var requireFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    type: SCROLL_TO_COMPONENT,
    payload: scrolledComponentKey,
    scrollingFocus: requireFocus
  };
}
export function clearsScrolledComponentKey() {
  return {
    type: CLEAR_SCROLLED_COMPONENT
  };
}